import { render, staticRenderFns } from "./CourseHistoryList.vue?vue&type=template&id=affc2b36"
import script from "./CourseHistoryList.vue?vue&type=script&lang=js"
export * from "./CourseHistoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports